var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenPokeball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 126.334 126.334",
    style: {
      enableBackground: "new 0 0 126.334 126.334"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF1A1A"
    },
    cx: 63.167,
    cy: 63.166,
    r: 61.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D60909"
    },
    cx: 63.167,
    cy: 63.166,
    rx: 61.667,
    ry: 47.232
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1.5,63.166c0,34.061,27.609,61.668,61.668,61.668c34.057,0,61.666-27.607,61.666-61.668H1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E5EA"
    },
    d: "M63.168,110.398c34.057,0,61.666-21.148,61.666-47.232H1.5 C1.5,89.25,29.109,110.398,63.168,110.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#80949B"
    },
    cx: 63.167,
    cy: 63.166,
    rx: 61.667,
    ry: 16.766
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#63797F"
    },
    cx: 63.167,
    cy: 63.166,
    rx: 41.321,
    ry: 11.234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E5054"
    },
    d: "M1.5,63.166c0-9.26,27.609-16.766,61.668-16.766c34.057,0,61.666,7.506,61.666,16.766"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363A"
    },
    d: "M63.168,0C28.337,0,0,28.336,0,63.166c0,34.831,28.337,63.168,63.168,63.168 c34.83,0,63.166-28.337,63.166-63.168C126.334,28.336,97.998,0,63.168,0z M122.976,64.666c-3.106,6.79-26.792,13.766-59.808,13.766 c-33.017,0-56.704-6.976-59.81-13.766H122.976z M3.358,61.666C6.464,54.876,30.151,47.9,63.168,47.9 c33.016,0,56.702,6.976,59.808,13.766H3.358z M63.168,3c31.089,0,56.745,23.702,59.85,53.985 C113.989,49.096,87.952,44.9,63.168,44.9c-24.785,0-50.823,4.195-59.852,12.084C6.421,26.702,32.078,3,63.168,3z M63.168,123.334 c-31.09,0-56.747-23.703-59.852-53.987c9.029,7.889,35.067,12.084,59.852,12.084c24.784,0,50.821-4.195,59.85-12.084 C119.913,99.631,94.257,123.334,63.168,123.334z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPokeball);
export default __webpack_public_path__ + "static/media/open-pokeball.26c9b52e.svg";
export { ForwardRef as ReactComponent };